import React from 'react';

export default function Footer() {
  return (
    <footer
      style={{
        marginTop: '40px',
        marginLeft: '-30px',
        marginRight: '-30px',
        marginBottom: '-30px',
        padding: '8px 20px',
        textAlign: 'center',
        borderTop: '1px solid #e5e5e5',
        backgroundColor: '#f8f9fa',
      }}
    >
      <span style={{ fontSize: '12px', color: '#6c757d' }}>
        Made with 💚 at 🐎. Have a recommendation for the digital napkin board?{' '}
        <a
          href="https://forms.gle/jhmREFhRr2CvrKLw8"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: '#006A52',
            fontWeight: 600,
            textDecoration: 'underline',
          }}
        >
          Send us a request
        </a>
      </span>
    </footer>
  );
}